import request from '@/utils/request'
import qs from 'qs'
export function getListDiscountBookingReport(query) {
  return request({
    url: '/report-service/v1/report/reservation-discount',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListDiscountBookingReportExcel(query) {
  return request({
    url: '/report-service/v1/report/reservation-discount/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}

export function getCreateUserOptions(data = {}) {
  return request({
    // user_group
    // 12: FO-All, 42: ANNINH, 46: Sale-All
    url: '/config-service/v1/account?userGroupIds=12&userGroupIds=46&userGroupIds=1',
    method: 'get',
    params: data,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
